import AModal from '@/components/A/AModal/AModal'
import styles from './ChangeAccountPasswordModal.module.less'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useState } from 'react'
import { FormItem } from '@/pages/ProjectCreatePage/components/StepOne/StepOne'
import APassword from '@/components/A/APassword/APassword'
import { api } from '@/api'
import { message } from 'antd'
import { useTranslation } from 'react-i18next'

interface Props {
  hasPassword: boolean
  onConfirm?: () => void
  onCancel?: () => void
}


function ChangeAccountPasswordModal(props: Props) {
  const { t } = useTranslation()
  const modal = useModal()
  const [password, setPassword] = useState<string>('')
  const [oldPassword, setOldPassword] = useState<string>('')
  const [passwordErrorMsg, setPasswordErrorMsg] = useState('')
  const [newPasswordErrorMsg, setNewPasswordErrorMsg] = useState('')
  const handleCancel = () => {
    props.onCancel?.()
    modal.hide()
  }
  const validator = (password: string) => {
    let msg1 = ''
    let msg2 = ''
    if (!oldPassword) {
      msg1 = t('login.message.text1')
    }
    if (!password) {
      msg2 = t('login.message.text1')
    } else {
      if (password.length < 12) {
        msg2 = t('login.message.text6')
      }
      const hasUpper = /[A-Z]/.test(password)
      const hasLower = /[a-z]/.test(password)
      const hasNumber = /[0-9]/.test(password)
      if (!hasUpper || !hasLower || !hasNumber) {
        msg2 = t('login.message.text7')
      }
    }
    return { msg1, msg2 }
  }
  const handleConfirm = async () => {
    const { msg1, msg2 } = validator(password)
    if (msg1 || msg2) {
      setPasswordErrorMsg(msg1)
      setNewPasswordErrorMsg(msg2)
      return
    }
    try {
      await api.staff.updatePassword({ newPassword: password, oldPassword }).send()
      message.success(t('dashboard.accountPage.message.passwordUpdatedSuccessfully'))
      modal.hide()
      props.onConfirm?.()
    } catch (e) {
      const error = e as ApiError
      if (error.statusCode === 40001) {
        setPasswordErrorMsg(t('dashboard.accountPage.message.incorrectEntryOfOriginalPassword'))
      }
    }
  }
  return (
    <AModal
      testId='account-change-password-modal'
      open={modal.visible}
      className={styles.changeAccountPasswordModal}
      title={t('dashboard.accountPage.message.setPassword')}
      confirmText={t('dashboard.accountPage.message.passwordConfirm')}
      cancelText={t('dashboard.accountPage.message.passwordCancel')}
      onCancel={handleCancel}
      onConfirm={handleConfirm}
      afterClose={() => {
        modal.remove()
      }}
    >
      {props.hasPassword && (
        <div>
          <FormItem
            label={t('dashboard.accountPage.message.oldPassword')}
            error={Boolean(passwordErrorMsg)}
            errorMsg={passwordErrorMsg}
          >
            <APassword
              testId='account-change-password-old-input'
              placeholder={t('dashboard.accountPage.message.pleaseEnterTheOldPassword')}
              onChange={(e) => {
                setOldPassword(e.target.value)
                setPasswordErrorMsg('')
              }}
            />
          </FormItem>
        </div>
      )}
      <div style={{ marginTop: 16, marginBottom: 20 }}>
        <FormItem label={t('dashboard.accountPage.message.newPassword')}
          error={Boolean(newPasswordErrorMsg)}
          errorMsg={newPasswordErrorMsg}
          errorMsgRender={(msg) => <span className={styles.errorMsg}>{msg}</span>}
        >
          <APassword
            testId='account-change-password-new-input'
            placeholder={t('dashboard.accountPage.message.pleaseEnterTheNewPassword')}
            onChange={(e) => {
              setPassword(e.target.value)
              setNewPasswordErrorMsg('')
            }}
            onBlur={() => {
              const { msg1, msg2 } = validator(password)
              setPasswordErrorMsg(msg1)
              setNewPasswordErrorMsg(msg2)
            }}
          />
        </FormItem>
      </div>
    </AModal>
  )
}

export default NiceModal.create(ChangeAccountPasswordModal)
